// removed by extract-text-webpack-plugin
module.exports = {"nf-account-admin":"nf-account-admin","nf-account-admin__content":"nf-account-admin__content","nf-account-admin__grid":"nf-account-admin__grid"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SuperAdminHome/SuperAdminHome.scss
// module id = 5524
// module chunks = 1